import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'reactstrap';
import ButtonDropdownCustom from 'components/CustomButton/ButtonDropdownCustom';
import styles from 'styles/Calendar.module.scss';
import { OPTION_EVENT_USER } from '../../../../constants/constants';
import { getColor, getColorText } from 'store/settings';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

const FooterLearner = ({
  event,
  onRegister,
  onUnregister,
  isSubmitting,
  onJoinRoom,
  isDisabled,
  renderRecorded,
}) => {
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
  `;
  return (
    <div
      className={classnames(
        styles.popoverFooter,
        'd-flex justify-content-between',
      )}
    >
      {renderRecorded()}

      {event?.optionUser == 'REGISTRY' ? (
        event?.registered ? (
          <Stylescal>
            <Button.Ripple
              className="round"
              color="danger"
              onClick={onUnregister}
              disabled={isSubmitting}
            >
              UnRegister
            </Button.Ripple>
          </Stylescal>
        ) : (
          <Stylescal>
            <Button.Ripple
              className="round"
              color="danger"
              onClick={onRegister}
              disabled={isSubmitting}
            >
              Register
            </Button.Ripple>
          </Stylescal>
        )
      ) : null}

      {/* {event?.registered ? (
        event?.optionUser == 'REGISTRY' && (
          <ButtonDropdownCustom
            title="Registered"
            disabledBtn
            // disabledMenu={
            //   [OPTION_EVENT_USER.ALL, OPTION_EVENT_USER.CUSTOM].indexOf(
            //     event?.optionUser,
            //   ) !== -1
            // }
            actions={[
              {
                text: 'Unregister',
                action: onUnregister,
              },
            ]}
            disabled={isSubmitting}
          />
        )
      ) : (
        <Stylescal>
          <Button.Ripple
            className="round"
            color="danger"
            onClick={onRegister}
            disabled={
              isSubmitting ||
              (event?.optionUser === OPTION_EVENT_USER.ALL &&
                event?.optionUser === OPTION_EVENT_USER.CUSTOM)
            }
          >
            Register
          </Button.Ripple>
        </Stylescal>
      )} */}
      <div className="d-flex align-items-center">
        {event?.registered && (
          <Stylescal>
            <Button.Ripple
              className={classnames(
                `round btn ${
                  isDisabled ? 'btn-danger' : 'btn-secondary disableButton'
                }`,
                styles[isDisabled ? '' : 'disableButton'],
              )}
              // className="round"
              // color="danger"
              onClick={onJoinRoom}
              disabled={!isDisabled | isSubmitting}
            >
              Join Room
            </Button.Ripple>
          </Stylescal>
        )}
      </div>
    </div>
  );
};

FooterLearner.propTypes = {
  event: PropTypes.object,
  onRegister: PropTypes.func.isRequired,
  onUnregister: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onJoinRoom: PropTypes.func.isRequired,
  renderRecorded: PropTypes.func.isRequired,
};

export default FooterLearner;
